import script from "./SetupAdrs.vue?vue&type=script&lang=ts&setup=true"
export * from "./SetupAdrs.vue?vue&type=script&lang=ts&setup=true"

import "./SetupAdrs.vue?vue&type=style&index=0&id=a8de7e6a&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8de7e6a"]])

export default __exports__